package com.ijoin.data.repository

import com.ijoin.data.api.ServiceProviderApi
import com.ijoin.data.model.CancelSlotsRequest
import com.ijoin.data.model.CreateTimeOffRequest
import com.ijoin.data.model.TimeOffType
import kotlinx.datetime.LocalDate

class ServiceProviderRepository(
    private val api: ServiceProviderApi = ServiceProviderApi(),
) {
    suspend fun cancelSlots(eventId: String, slotIds: List<Long>, reason: String?): Result<Unit> {
        if (slotIds.isEmpty()) {
            return Result.failure(IllegalArgumentException("No slots selected"))
        }
        val request = CancelSlotsRequest(slotIds = slotIds, reason = reason)
        return api.cancelSlots(eventId, request)
    }

    suspend fun cancelSlotDay(eventId: String, date: LocalDate, reason: String?): Result<Unit> {
        val request = CreateTimeOffRequest(
            startDate = date,
            endDate = date,
            type = TimeOffType.OTHER,
            reason = reason,
        )
        return api.addEventTimeOff(eventId, request)
    }

    suspend fun restoreSlots(eventId: String, slotIds: List<Long>): Result<Unit> {
        if (slotIds.isEmpty()) {
            return Result.failure(IllegalArgumentException("No slots selected"))
        }
        return api.restoreSlots(eventId, slotIds)
    }

    suspend fun restoreSlotDay(eventId: String, date: LocalDate): Result<Unit> {
        return api.restoreEventDay(eventId, date.toString())
    }
}
